import * as React from 'react';

const ErrorIcon = (props) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="40" cy="40" r="40" fill="#F9FAFB" />
    <circle cx="40" cy="40" r="21" fill="#F04438" />
    <path
      d="M40 19C34.4305 19 29.089 21.2125 25.1508 25.1508C21.2125 29.089 19 34.4305 19 40C19 45.5695 21.2125 50.911 25.1508 54.8492C29.089 58.7875 34.4305 61 40 61L40 40V19Z"
      fill="#FDA29B"
    />
    <rect x="37.0586" y="26.5605" width="5.87971" height="17.6391" rx="2.93985" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.938 29.5004C42.938 27.8768 41.6218 26.5605 39.9981 26.5605V44.1997C41.6218 44.1997 42.938 42.8835 42.938 41.2598V29.5004Z"
      fill="#E4E7EC"
    />
    <circle cx="39.9986" cy="50.5005" r="2.94" fill="#E4E7EC" />
    <path
      d="M39.9986 47.5605C39.2189 47.5605 38.4711 47.8703 37.9197 48.4217C37.3683 48.973 37.0586 49.7208 37.0586 50.5005C37.0586 51.2803 37.3683 52.0281 37.9197 52.5794C38.4711 53.1308 39.2189 53.4405 39.9986 53.4405L39.9986 50.5005V47.5605Z"
      fill="white"
    />
  </svg>
);
export default ErrorIcon;
